import React, { useEffect, useState } from 'react';
import { CheckCircle } from 'lucide-react';
const purchases = [{
  name: 'Carlos M.',
  location: 'Rosario, Santa Fe'
}, {
  name: 'Javier P.',
  location: 'Córdoba Capital'
}, {
  name: 'Alejandro R.',
  location: 'Avellaneda, Buenos Aires'
}, {
  name: 'Marcelo D.',
  location: 'Mendoza Capital'
}, {
  name: 'Gustavo F.',
  location: 'San Miguel de Tucumán'
}, {
  name: 'Daniel S.',
  location: 'Neuquén Capital'
}, {
  name: 'Pablo L.',
  location: 'Mar del Plata, Buenos Aires'
}, {
  name: 'Fernando G.',
  location: 'Salta Capital'
}];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState(purchases[0]);
  useEffect(() => {
    const initialTimer = setTimeout(() => {
      showNextPopup();
    }, 5000);
    return () => clearTimeout(initialTimer);
  }, []);
  const showNextPopup = () => {
    const randomPurchase = purchases[Math.floor(Math.random() * purchases.length)];
    setCurrentPurchase(randomPurchase);
    setIsVisible(true);
    setTimeout(() => {
      setIsVisible(false);
      const nextDelay = Math.floor(Math.random() * 10000) + 10000;
      setTimeout(showNextPopup, nextDelay);
    }, 4000);
  };
  if (!isVisible) return null;
  return <div className="fixed bottom-4 left-4 z-50 animate-[slideIn_0.5s_ease-out] max-w-[280px] md:max-w-[300px]" data-id="element-273">
      <div className="bg-brand-card rounded-lg shadow-2xl border-2 border-brand-accent p-3 flex items-start gap-2.5 relative overflow-hidden" data-id="element-274">
        <div className="bg-brand-accent/20 p-1.5 rounded-full shrink-0" data-id="element-275">
          <CheckCircle className="w-5 h-5 text-brand-accent" data-id="element-276" />
        </div>
        <div data-id="element-277">
          <p className="text-xs md:text-sm text-gray-200 font-medium leading-tight mb-0.5" data-id="element-278">
            <span className="font-bold text-white" data-id="element-279">{currentPurchase.name}</span>{' '}
            de {currentPurchase.location} acaba de comprar el Kit Digital ⚡
          </p>
          <p className="text-[10px] text-brand-accent font-bold" data-id="element-280">
            Hace unos minutos
          </p>
        </div>
      </div>
      <style data-id="element-281">{`
        @keyframes slideIn {
          from { transform: translateX(-120%); opacity: 0; }
          to { transform: translateX(0); opacity: 1; }
        }
      `}</style>
    </div>;
}